const semanticClassNames = {
  root: 'fast-gallery',
  container: 'fast-gallery__container',
  overlay: 'fast-gallery__overlay',
  item: 'fast-gallery__item',
  content: 'fast-gallery__content',
  media: 'fast-gallery__media',
  details: 'fast-gallery__details',
  image: 'fast-gallery__image',
  info: 'fast-gallery__info',
  counter: 'fast-gallery__counter',
} as const;

export default semanticClassNames;
